module.exports = __webpack_public_path__ + "static/media/camping-03.a8b92291.jpg";